"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const dandruffhair = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-dandruffhair` : '') + (description ? ` desc-dandruffhair` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-dandruffhair"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-dandruffhair"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.68 12.69c.4 0 .7.25.83.52.12.26.14.6-.04.9-.35.6-.5 1.68-.15 2.6.17.43.44.81.83 1.08.38.27.93.47 1.71.47a3 3 0 0 0 1.73-.47c.4-.27.67-.66.85-1.1.36-.93.24-2.01-.09-2.6a.95.95 0 0 1 0-.9.9.9 0 0 1 .81-.5h8.04a.75.75 0 0 1 0 1.5H16c.25.92.23 2.05-.17 3.05a3.87 3.87 0 0 1-1.39 1.78c-.68.47-1.54.74-2.58.74a4.4 4.4 0 0 1-2.57-.74 3.78 3.78 0 0 1-1.37-1.79c-.38-1-.38-2.12-.1-3.04H.88a.75.75 0 0 1 0-1.5h7.8Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.2 3.84a.4.4 0 0 1 .32.1c.17.17.15.41.04.58-.68 1-1.8 2.76-2.22 4.17-.16.56-.3 1.17-.41 1.77l.44.03.1-.01a.6.6 0 0 1 .72.93c-.16.19-.4.23-.47.25l-.34.03c-.2 0-.41-.02-.62-.04a9.5 9.5 0 0 0-.04 1.02c.01.33.06.55.1.65.17.31.38.7.55 1.13.17.42.31.89.31 1.39 0 .5-.16.97-.48 1.31a1.7 1.7 0 0 1-1.3.55c-.49 0-1-.11-1.39-.44-.4-.34-.63-.87-.63-1.59 0-.6.23-1.18.44-1.6a5.7 5.7 0 0 1 .39-.64v-.12l.12-.67c.07-.33.17-.76.33-1.33l-.23-.08a10.02 10.02 0 0 1-.85-.35c-.06-.04-.17-.1-.27-.2a.6.6 0 0 1 .86-.83c-.04-.05-.06-.05-.01-.03l.16.08.52.2.16.05.2-.65a14 14 0 0 1 3.23-5.53l.06-.05a.44.44 0 0 1 .22-.08Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M22.66 9.45a.6.6 0 0 1 1.13.42c-.23.6-.74.87-1.17.99-.42.1-.86.1-1.14.05a.6.6 0 0 1 .2-1.19c.15.03.41.03.63-.02.22-.06.31-.15.35-.25Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.3 8.47a.6.6 0 0 1 .92.73l-.07.1v.01l-.03.03a2.2 2.2 0 0 1-.26.26c-.17.15-.44.34-.78.42a4.7 4.7 0 0 1-1.2.1h-.04a.6.6 0 0 1 0-1.2h.03a7.9 7.9 0 0 0 .92-.07.75.75 0 0 0 .29-.16 1.29 1.29 0 0 0 .13-.13l.08-.09Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.6 8.04a.6.6 0 0 1 .5.7c-.07.35-.3.59-.51.73-.22.14-.47.22-.7.28-.45.1-1 .12-1.4.02a.6.6 0 0 1 .3-1.17c.17.05.52.05.83-.02a.9.9 0 0 0 .3-.12h.01a.6.6 0 0 1 .67-.42Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.64 7.5a.6.6 0 0 1 .67 1l-.38-.46.38.46h-.01l-.04.04a5.31 5.31 0 0 1-.49.35 3.3 3.3 0 0 1-1.17.5 3.32 3.32 0 0 1-1.5-.19 6.52 6.52 0 0 1-.67-.27l-.04-.02h-.01a.6.6 0 1 1 .53-1.07c0-.01 0-.01 0 0h.03l.12.06.42.16c.37.12.71.19.92.15.19-.03.46-.16.72-.33a5.13 5.13 0 0 0 .4-.28l.02-.02.1-.07Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.4 6.84a.6.6 0 0 1 .5.7c-.07.35-.3.59-.51.73-.22.14-.46.22-.7.28-.45.1-1 .12-1.4.02a.6.6 0 0 1 .3-1.17c.18.05.52.05.83-.02a.9.9 0 0 0 .3-.12h.01a.6.6 0 0 1 .67-.42Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11 5.64a.6.6 0 0 1 .5.7c-.07.35-.3.59-.51.73-.22.14-.47.22-.7.28-.45.1-1 .12-1.4.02a.6.6 0 0 1 .3-1.17c.18.05.52.05.83-.02a.9.9 0 0 0 .3-.12h.01a.6.6 0 0 1 .67-.42Z",
    fill: "#232323"
  }));
};
var _default = exports.default = dandruffhair;